import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function stripAudioLabel(name) {
  if (!name) {
    return name;
  }
  return name.replace(/\s*\(Audio\)\s*/g, " ").replace(/\s{2,}/g, " ").trim();
}

export function formatLanguageName(name) {
  if (!name) {
    return name;
  }
  const withoutAudio = stripAudioLabel(name);
  return withoutAudio.replace(/\s*\[[^\]]*\]\s*/g, " ").replace(/\s{2,}/g, " ").trim();
}
